<template>
    <div class="sidebar">
        <b-navbar class="drop-shadow p-3" variant="success">
            <b-navbar-brand class="text-white p-0" href="/">{{ title }}</b-navbar-brand>
        </b-navbar>
        <b-progress :value="loadingProgress" :max="100" v-if="loadingProgress < 100" animated></b-progress>
        <div class="m-0 p-0" role="tablist">
            <folding-panel id="import" icon="file" title="Import dataset">
                <import-form></import-form>
            </folding-panel>
            <folding-panel id="currentSelection" icon="info" title="Current selection">
                <selection-summary></selection-summary>
            </folding-panel>
            <folding-panel id="options" icon="sliders-h" title="Options">
                <setting-panel></setting-panel>
            </folding-panel>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import FoldingPanel from "./FoldingPanel";
    import SelectionSummary from "./SelectionSummary";
    import ImportForm from "./ImportForm";
    import SettingPanel from "./SettingPanel";

    export default {
        name: "SideBar",
        components: {
            SettingPanel,
            FoldingPanel,
            SelectionSummary,
            ImportForm
        },
        data() {
            return {
                title: 'CoPHI'
            };
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters(['loadingProgress'])
        }
    };
</script>

<style scoped lang="less">
    @import "../variables.less";
    @import "../mixins.less";
    @import "../icons.less";

    nav {
        .bar(@accent-color);
        .shadows(@deeper-color);

        .navbar-brand {
            font-weight: 900;
            font-variant: all-small-caps;
            color: @not-so-white;
            font-size: @font-big-title;
            text-shadow: 1px 1px rgba(0, 0, 0, 0.1);
        }
    }

    .sidebar {
        max-height: 100vh;
        overflow-y: scroll ;
    }

</style>
